// extracted by mini-css-extract-plugin
module.exports = {"rowData":"TheOrgDetails_rowData_2vouC"};